// extracted by mini-css-extract-plugin
module.exports = {"loadBox":"UKCheckbox_loadBox__U48zm"};